import type * as React from 'react';
import { put } from '@Domain/Api';
import organizationWorkflowSaved, {
	type OrganizationWorkflowSavedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowSaved';
import organizationWorkflowSaveFailed, {
	type OrganizationWorkflowSaveFailedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowSaveFailed';
import type { OrganizationWorkflowPayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';
import type SaveOrganizationWorkflow from '@Application/Organizations/Workflows/Commands/SaveOrganizationWorkflow';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationWorkflowSavedAction | OrganizationWorkflowSaveFailedAction;

/** Publishes a new version of the group addressed by the command's `workflowKey` (required). */
export default (command: SaveOrganizationWorkflow) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			if (command.workflowKey === null) {
				throw new Error('A workflow key is required to save an existing group.');
			}

			const response = await put<OrganizationWorkflowPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/workflows/${command.workflowKey}`,
				command.toJSON(),
			);

			const action = organizationWorkflowSaved(response, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationWorkflowSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
